import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-8 gap-4 mb-4 header-filter" }
const _hoisted_2 = { class: "flex items-center gap-4 col-span-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-sm text-primary" }, /*#__PURE__*/_toDisplayString("Hari Ini"), -1)
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-left" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "col-span-4" }
const _hoisted_10 = { class: "flex gap-12 justify-center items-center" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "txt-day" }
const _hoisted_13 = { class: "txt-date" }
const _hoisted_14 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Susun Ulang Jadwal'), -1)

import { ref, onMounted, watch, computed, reactive } from 'vue'
import Button from 'primevue/button'
import { DatePicker } from 'v-calendar'
import moment from 'moment'
import InputText from 'primevue/inputtext'
import HjpCofirmModal from '@/views/components/modal/HjpConfirmationModal.vue'
import { debounce } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderFilter',
  props: {
  modelValue: {
    type: [Date, String],
    default: ''
  },
  isRoster: {
    type: Boolean,
    default: () => false
  },
  isAirport: {
    type: Boolean,
    default: () => false
  }
},
  emits: ["update:modelValue", "generateRoster", "showFormRosterContinue", "checkIsToday"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: Date): void,
  (e: 'generateRoster'): void
  (e: 'showFormRosterContinue'): void,
  (e: 'checkIsToday', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const weekStart = ref(moment().clone().startOf('week'))
const weekEnd = ref(moment().clone().endOf('week'))
const rangeDate = ref<Date[]>([])
const selectedDateFilter = computed({
  get: () => props.modelValue,
  set: (v) => {
    if (v instanceof Date) {
      emit('update:modelValue', v)
    }
  }
})
const isToday = ref(true)
const pickerDate = ref(moment().toDate())
const pickerMaxDate = ref(moment().toDate())

const modalConfirmation = reactive({
  show: false,
  imgContent: require('@/assets/img/modal-confirmation/schedule.svg'),
  title: 'Susun Ulang Jadwal ?',
  subTitle: 'Dengan menyusun ulang jadwal maka akan ada penyesuaian jadwal roster dengan plotting yang terbaru',
  btnSubmitTitle: 'Lanjutkan Susun Ulang Jadwal',
})

const hideConfirmDialog = () => {
  modalConfirmation.show = false
}

const showConfirmDialog = () => {
  modalConfirmation.show = true
}

const getRange = () => {
  const countRange = weekEnd.value.diff(weekStart.value, 'days')
  const rangeDateTemp = []
  for (let i = 0; i < countRange + 1; i++) {
    const newDate = moment(weekStart.value).add(i, 'd').endOf('date')
    rangeDateTemp.push(newDate.toDate())
  }
  rangeDate.value = rangeDateTemp
}

const classDate = (val: Date) => {
  let classExist = ''
  const dateParam = moment(moment(val).format('YYYY-MM-DD'))
  if (selectedDateFilter.value && dateParam.isSame(moment(selectedDateFilter.value).format('YYYY-MM-DD'))) {
    classExist = 'date-selected'
  } else if (dateParam.isSame(moment().format('YYYY-MM-DD'))) {
    classExist = 'date-now'
  }
  return classExist
}

const choiceDate = (val: Date) => {
  console.log('check', moment(val).isSameOrAfter(moment(), 'day'))
  selectedDateFilter.value = val
  isToday.value = moment(val).isSameOrAfter(moment(), 'day')
  emit('checkIsToday', isToday.value)
}

const processPickerDate = (newVal: Date) => {
  weekStart.value = moment(newVal)
  weekEnd.value = moment(newVal).add(6, 'd')
  getRange()
}

const choiceToday = () => {
  selectedDateFilter.value = moment().toDate()
  pickerDate.value = moment().toDate()
}

watch(pickerDate, debounce(processPickerDate, 500))

const generateRoster = () => {
  hideConfirmDialog()
  emit('generateRoster')
}

const showFormRosterContinue = () => {
  emit('showFormRosterContinue')
}

onMounted(() => {
  getRange()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createVNode(_unref(Button), {
            class: "flex gap-2 extra-submit-button p-3",
            outlined: true,
            onClick: choiceToday
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "background-white rounded-l-lg px-3 py-2 border-right-white-darken-2 cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (pickerDate.value = _unref(moment)(weekStart.value).subtract(7, 'd').toDate()))
          }, _hoisted_6),
          _createElementVNode("div", {
            class: "background-white rounded-r-lg px-3 py-2 cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (pickerDate.value = _unref(moment)(weekStart.value).add(7, 'd').toDate()))
          }, _hoisted_8)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rangeDate.value, (date, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "cursor-pointer",
              onClick: ($event: any) => (choiceDate(date))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(`wrap-date ${classDate(date)}`)
              }, [
                _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(moment)(date).format('ddd')), 1),
                _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(moment)(date).format('DD')), 1)
              ], 2)
            ], 8, _hoisted_11))
          }), 128))
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["flex items-center", (__props.isRoster || __props.isAirport) && isToday.value ? '' : 'col-span-2'])
      }, [
        _createVNode(_unref(DatePicker), {
          modelValue: pickerDate.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((pickerDate).value = $event)),
          masks: {
        input: 'YYYY-MM-DD'
      }
        }, {
          default: _withCtx(({ togglePopover, inputValue }) => [
            _createVNode(_unref(InputText), {
              id: "end-date",
              placeholder: "Masukkan tanggal mulai",
              value: inputValue ? `${_unref(moment)(inputValue).format('DD MMMM YYYY')}` : inputValue,
              class: _normalizeClass(`input-default`),
              onClick: togglePopover,
              readonly: true
            }, null, 8, ["value", "onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 2),
      (__props.isRoster && isToday.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_unref(Button), {
              class: "mb-2 sm:mb-0 flex gap-2 w-full",
              style: {"padding":"8px"},
              onClick: showConfirmDialog
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(HjpCofirmModal, {
      show: modalConfirmation.show,
      title: modalConfirmation.title,
      subTitle: modalConfirmation.subTitle,
      subTitleHtml: modalConfirmation.subTitleHtml,
      btnSubmitTitle: modalConfirmation.btnSubmitTitle,
      imgContent: modalConfirmation.imgContent,
      onHideDialog: hideConfirmDialog,
      onOnSubmit: generateRoster
    }, null, 8, ["show", "title", "subTitle", "subTitleHtml", "btnSubmitTitle", "imgContent"])
  ], 64))
}
}

})